export default "__VITE_ASSET__7b3d3d22__"